import React from 'react';
import './CardSlider.css';
import balcony from "../../Images/balcony.jpg"
import { motion } from "framer-motion";
import ServicesGrid from '../Services/Services';

// Placeholder data for the cards
const packages = [
  { name: 'Kitchen Package', price: '55,680', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Bedroom Package', price: '62,400', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Living Room Pkg', price: '71,150', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Full Home Pkg', price: '1,95,300', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Bathroom Package', price: '34,999', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Kitchen Package', price: '55,680', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Bedroom Package', price: '62,400', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Living Room Pkg', price: '71,150', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Full Home Pkg', price: '1,95,300', imgSrc: 'BALCONY_IMAGE_URL' },
  { name: 'Bathroom Package', price: '34,999', imgSrc: 'BALCONY_IMAGE_URL' },
];


const Card = ({ name, price, imgSrc }) => (
  <div className="card-item">
    {/* The image is a critical part of the visual. 
        In a real app, replace 'BALCONY_IMAGE_URL' with the actual path/URL. */}
    <div className="card-image-wrapper">
      <img src={imgSrc} alt={name} /> 
    </div>
    <div className="card-content">
      <h3 className="card-title">{name}</h3>
      <span className="card-price">{price}/-</span>
    </div>
    <p className="card-description">
      From design to finishing, our experts handle every step with precision and care
    </p>
    <a href="/" className="card-book-link">
      Book now →
    </a>
  </div>
);

const CardSlider = () => {
    const stats = [
    { value: "8K+", label: "Customers" },
    { value: "350+", label: "Projects" },
    { value: "50+", label: "City" },
  ];
  return (
    <div className="card-slider-container" id='projects'>
      {/* --- Header Section --- */}
      <div className="header-content">
        <h2 className="main-heading">What made US Special ?</h2>
        <p className="sub-heading" style={{color:"#e78610"}}>
          Your home deserves a makeover that reflects your lifestyle. From design to
          finishing, our experts handle every step with precision and care.
        </p>
      </div>

      {/* --- Card Slider Section (For React Slick Integration) --- */}
   
       
         <ServicesGrid/>
   
 

      <div className="user-project-container">
        {stats.map((item, index) => (
          <motion.div
            key={index}
            className="stat-box"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <motion.span
              className="stat-value"
              initial={{ scale: 0.5, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              {item.value}
            </motion.span>

            <motion.span
              className="stat-label"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.3 }}
            >
              {item.label}
            </motion.span>
          </motion.div>
        ))}
      </div>

    
    </div>
  );
};

export default CardSlider;